import * as React from 'react';
import {useForm, Path, UseFormRegister, SubmitHandler} from 'react-hook-form';
import BlogPostSelectSeasonGeneric from './BlogPostSelectSeasonGeneric';
import BlogPostSelectCompGeneric from './BlogPostSelectCompGeneric';
import BlogPostSelectRoundBaseV2 from './BlogPostSelectRoundBaseV2';
import {BlogPostTextInputV2} from './BlogPostTextInputV2';
import {BlogPostNumberInput} from './BlogPostNumberInput';
import {BlogPostCheckBox} from './BlogPostCheckBox';
import {BlogPostSelectCategories} from './BlogPostSelectCategories';
//import BlogPostSelectRoundBaseV2 from './BlogPostSelectRoundBaseV2';
import {getFACompByType, getFAComp, useClubDetail} from '@nls-2022/nls-bll';
import {FACompResultBlogContentType} from '@nls-2022/nls-bll';
import BlogPostSelectCompBase from './BlogPostSelectCompBase';
import {
  generateBlogPostContentFromCompResultBlogPost,
  generateTwitterPostContentFromCompResultBlogPost,
} from '@nls-2022/nls-bll';
import {ClubsContext} from '../../../containers/blog/BlogManagerContainer';

export type BlogPostNewFACompResultInputFormPropsType = {
  blogPost: FACompResultBlogContentType;
  initInputForm: boolean;
  setInitInputForm: any;
  setGeneratedBlogPostContent: any;
  setGeneratedTwitterPostContent: any;
};

export interface ICompInputFormValues {
  Season: string;
  Comp: string;
  Round: string;
  Title: string;
  WinningClub: string;
  LosingClub: string;
  Pens: boolean;
  Aet: boolean;
  Score: string;
  IsPublished: boolean;
  Categories: Array<string>;
  PubDate: string;
}

export type InputProps = {
  label: Path<ICompInputFormValues>;
  register: UseFormRegister<ICompInputFormValues>;
  required: boolean;
  rest: any;
};
const publishDaysFactor: number = 5;
const formatDate = (date: string): string => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};
const publishedDate = (_date: string): string => {
  let convertedDate = new Date(_date);
  convertedDate.setDate(convertedDate.getDate() - publishDaysFactor);
  return formatDate(convertedDate.toDateString());
};

const BlogPostNewFACompResultInputForm = ({
  //setGeneratedBlogPost,
  blogPost,
  initInputForm,
  setInitInputForm,
  setGeneratedBlogPostContent,
  setGeneratedTwitterPostContent,
}: //initInputForm,
BlogPostNewFACompResultInputFormPropsType) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors},
  } = useForm<ICompInputFormValues>();
  //alert('render BlogPostNewFACompInputForm' + blogPost.roundName);
  console.log('Input Form V2 ' + watch('Round'));
  console.log('Input Form V2 categories' + blogPost.categories);
  //console.log('Blog Post RoundName ' + blogPost.roundName);
  const [updatedBlogPost, setUpdatedBlogPost] = React.useState(blogPost);
  const selectedSeason = watch('Season', blogPost.season);
  //const [selectedSeason, setSelectedSeason] = React.useState(blogPost.season);
  const selectedComp = watch('Comp', getFACompByType(blogPost!.comp)!.name);
  //const [selectedComp, setSelectedComp] = React.useState(
  //  getFACompByType(blogPost!.comp)!.name,
  //);
  const selectedCategories = watch('Categories', blogPost.categories);
  //const selectedRound = watch('Round', blogPost.roundName);
  const selectedIsPublished = watch('IsPublished', blogPost.isPublished);
  //const [selectedRound, setSelectedRound] = React.useState(blogPost.roundName);
  const selectedTitle = watch('Title', blogPost.title);
  //const [title, setTitle] = React.useState(blogPost.title);
  const selectedPubDate = watch(
    'PubDate',
    blogPost.pubDate !== '' ? blogPost.pubDate : '',
  );
  const selectedAet = watch('Aet', blogPost.aet);
  const selectedPens = watch('Pens', blogPost.pens);
  const selectedScore = watch('Score', blogPost.score);
  const selectedWinningClub = watch('WinningClub', blogPost.winningClub);
  const selectedLosingClub = watch('LosingClub', blogPost.losingClub);
  const [winningClubsState, dispatchWinningClubs] = useClubDetail(
    blogPost.winningClub,
  );
  const [losingClubsState, dispatchLosingClubs] = useClubDetail(
    blogPost.losingClub,
  );
  //let winningClub = clubs.

  const generateBlogPostContent = (
    _updatedBlogPost: FACompResultBlogContentType,
  ) => {
    //console.log('Gernerate Blog Post');
    //console.log(_updatedBlogPost.title);
    //console.log('After GenerateBlogPost');
    setGeneratedBlogPostContent(
      generateBlogPostContentFromCompResultBlogPost(_updatedBlogPost),
    );
  };
  const generateTwitterPostContent = (
    _updatedBlogPost: FACompResultBlogContentType,
  ) => {
    //console.log('Gernerate Blog Post');
    //console.log(_updatedBlogPost.title);
    //console.log('After GenerateBlogPost');
    setGeneratedTwitterPostContent(
      generateTwitterPostContentFromCompResultBlogPost(_updatedBlogPost),
    );
  };

  //const generatedBlogPostContent =
  //  generateBlogPostContentFromCompBlogPost(undefined);

  React.useEffect(() => {
    const initForm = () => {
      setUpdatedBlogPost(blogPost);
      setValue('Season', blogPost.season);
      setValue('IsPublished', blogPost.isPublished);
      setValue('Comp', getFACompByType(blogPost!.comp)!.name);
      setValue('Title', blogPost.title);
      setValue('PubDate', blogPost.pubDate !== '' ? blogPost.pubDate : '');
      //setValue('Round', blogPost.roundName);
      setValue('Categories', blogPost.categories);
      setValue('Aet', blogPost.aet);
      setValue('Pens', blogPost.pens);
      setValue('Score', blogPost.score);
      setValue('WinningClub', blogPost.winningClub);
      setValue('LosingClub', blogPost.losingClub);
    };
    initForm();
    setInitInputForm(false);
  }, [
    blogPost,
    setInitInputForm,
    initInputForm,
    setGeneratedBlogPostContent,
    setGeneratedTwitterPostContent,
    setValue,
  ]);
  //console.log({selectedCategories});
  const onSubmit: SubmitHandler<ICompInputFormValues> = data => {
    //alert(selectedCategories);
    let _updatedBlogPost = {
      ...updatedBlogPost,
      season: selectedSeason,
      isPublished: selectedIsPublished,
      comp: getFAComp(selectedComp)?.comp!,
      title: selectedTitle,
      categories: selectedCategories,
      pubDate: selectedPubDate,
      score: selectedScore,
      winningClub: selectedWinningClub,
      losingClub: selectedLosingClub,
      pens: selectedPens,
      aet: selectedAet,
      winningClubDetail: winningClubsState.clubDetail,
      losingClubDetail: losingClubsState.clubDetail,
    };
    setUpdatedBlogPost(_updatedBlogPost);
    generateBlogPostContent(_updatedBlogPost);
    generateTwitterPostContent(_updatedBlogPost);
  };
  return (
    <section id="enterfacomp">
      <h3>Blog Comp Details</h3>
      <form
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Season
          </label>

          <BlogPostSelectSeasonGeneric
            register={register}
            setValue={setValue}
            selectedSeason={selectedSeason}
          />
        </div>

        <BlogPostSelectCompGeneric
          register={register}
          setValue={setValue}
          selectedSeason={selectedSeason}
          selectedComp={selectedComp}
          compBySeason={[]}
        />

        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedPubDate}
          name="PubDate"
          label="Published Date"
        />

        <BlogPostCheckBox
          register={register}
          defaultValue={true}
          name="IsPublished"
          label="Published"
          checked={selectedIsPublished}
        />
        <BlogPostSelectCategories
          register={register}
          selectedCategories={selectedCategories}
          name="Categories"
          label="Categories"
        />

        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedTitle}
          name="Title"
          label="Title"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedWinningClub}
          name="WinningClub"
          label="Winning Club"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedLosingClub}
          name="LosingClub"
          label="Losing Club"
        />

        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedScore}
          name="Score"
          label="Score"
        />
        <BlogPostCheckBox
          register={register}
          defaultValue={true}
          name="Pens"
          label="Pens"
          checked={selectedPens}
        />
        <BlogPostCheckBox
          register={register}
          defaultValue={true}
          name="Aet"
          label="Aet"
          checked={selectedAet}
        />

        <button
          type="submit"
          className="flex-shrink-0 bg-green-500 hover:bg-green-700 border-green-500 hover:border-green-700 text-sm border-4 text-white py-1 px-2 rounded uppercase"
        >
          generate
        </button>
      </form>
    </section>
  );
};

export default BlogPostNewFACompResultInputForm;
